export const IS_CHANGE = "IS_CHANGE"
export const SIDE_STATUS = "SIDE_STATUS"
export const IS_SOCKET_DETECT = "IS_SOCKET_DETECT"
export const IS_SOCKET_DETECT_BTN = "IS_SOCKET_DETECT_BTN"
export const IS_DETECT_LOADING = "IS_DETECT_LOADING"